import { loadPrefs } from '@/lib/prefs';

// Glasses / hands-free alerts: speak and/or buzz the verdict. Works on web + Android WebView.
export function announce({ score, label, summary }) {
  const { alert_mode } = loadPrefs();
  const voice = alert_mode === 'voice' || alert_mode === 'all';
  const buzz = alert_mode === 'vibrate' || alert_mode === 'all';
  if (buzz && navigator.vibrate) {
    navigator.vibrate(score >= 70 ? [600] : score >= 45 ? [120, 80, 120, 80, 120] : [80]);
  }
  if (voice && 'speechSynthesis' in window) {
    const u = new SpeechSynthesisUtterance(`${label}. Risk ${Math.round(score)} out of 100. ${summary || ''}`.slice(0, 300));
    u.rate = 1.05;
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(u);
  }
}
